export const HJID = 5096823;
export const HJSV = 6;
